import { ContextType, createContext, useState } from "react";

type App = {
  platformId: string;
  apiUrl: string;
  appIconNames: string[];
  referralCode: string;
};

export const AppContext = createContext({
  platformId: "",
  referralCode: "",
  apiUrl: "",
  appIconNames: [] as string[],
  setPlatformId: (id: string): void => undefined,
  setApiUrl: (url: string): void => undefined,
  setAppIcons: (icons?: string[]): void => undefined,
  setReferralCode: (setReferralCode: string): void => undefined,
  clear: (): void => undefined,
});

export const useAppState = (): ContextType<typeof AppContext> => {
  const [app, setApp] = useState<App>({
    platformId: localStorage.getItem("platformId") || "",
    apiUrl: localStorage.getItem("baseApiUrl") || "",
    appIconNames: JSON.parse(localStorage.getItem("iconNames") || "[]"),
    referralCode: localStorage.getItem("referralCode") || "",
  });
  return {
    platformId: app.platformId,
    apiUrl: app.apiUrl,
    appIconNames: app.appIconNames,
    referralCode: app.referralCode,
    setPlatformId: (id) => {
      if (!id) {
        localStorage.removeItem("platformId");
      } else {
        localStorage.setItem("platformId", id);
      }
      setApp({ ...app, platformId: id });
    },
    setApiUrl: (url) => {
      if (!url) {
        localStorage.removeItem("baseApiUrl");
      } else {
        localStorage.setItem("baseApiUrl", url);
      }
      setApp({ ...app, apiUrl: url });
    },
    setAppIcons: (icons) => {
      if (!icons) {
        localStorage.removeItem("iconNames");
      } else {
        localStorage.setItem("iconNames", JSON.stringify(icons));
      }
      setApp({ ...app, appIconNames: icons || [] });
    },
    setReferralCode: (referralCode) => {
      if (!referralCode) {
        localStorage.removeItem("referralCode");
      } else {
        localStorage.setItem("referralCode", referralCode);
      }
      setApp({ ...app, referralCode });
    },
    clear: () => {
      localStorage.removeItem("platformId");
      localStorage.removeItem("baseApiUrl");
      localStorage.removeItem("referralCode");
      setApp({
        ...app,
        platformId: "",
        apiUrl: "",
        referralCode: "",
      });
    },
  };
};
